import { render } from "./StatsUserRetention.vue?vue&type=template&id=34bbd69e"
import script from "./StatsUserRetention.vue?vue&type=script&lang=js"
export * from "./StatsUserRetention.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fae/dev/grazer/grazer-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__